var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbotTranscriptsIcon = function SvgChatbotTranscriptsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.94c0 .584-.476 1.06-1.06 1.06H7l-3 2v-2h-.94C2.476 17 2 16.524 2 15.94V5.059C2 4.475 2.476 4 3.06 4h14.88c.584 0 1.06.475 1.06 1.059zM17.94 3H3.06A2.06 2.06 0 0 0 1 5.059V15.94A2.06 2.06 0 0 0 3.06 18H3v1.226a1 1 0 0 0 1.521.861L8 18h9.94A2.06 2.06 0 0 0 20 15.94V5.059A2.06 2.06 0 0 0 17.94 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm4 1H4v5h4zM11 7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm2 1h-2v5h2zM15 8a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm1 0h1v5h-1z",
    clipRule: "evenodd"
  })));
};
export default SvgChatbotTranscriptsIcon;